import { type Abi } from 'viem';

import kycManagerAbiJson from './abiKycManager.json';
import poolContractAbiJson from './abiPoolContract.json';
import predictionContractAbiJson from './abiPredictionContract.json';
import stakingContractAbiJson from './abiStakingContract.json';
import erc20AbiJson from './erc20.json';

// Properly typed ABIs with function names and arguments preserved
export const kycManagerAbi = kycManagerAbiJson as Abi;
export const poolContractAbi = poolContractAbiJson as Abi;
export const erc20Abi = erc20AbiJson as Abi;
export const predictionContractAbi = predictionContractAbiJson as Abi;
export const stakingContractAbi = stakingContractAbiJson as Abi;

// Re-export the JSON for backward compatibility if needed
export {
  kycManagerAbiJson,
  poolContractAbiJson,
  erc20AbiJson,
  predictionContractAbiJson,
  stakingContractAbiJson
};
